import * as React from "react";
import Image from "next/image";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import Dialog from "src/components/Dialog";
// import Icon from "../Icon";
import Link from "next/link";
import Button from "@src/components/Button";
import { GetAlbumDetailsQuery } from "@src/@types/api.d";

type Props = {
  eventId: number;
  albumDetailsData: GetAlbumDetailsQuery;
  eventSlug: string;
};

export function insertAt(
  array: unknown[],
  index: number,
  ...elementsArray: unknown[]
) {
  array.splice(index, 0, ...elementsArray);
}

const Masonry: React.FC<Props> = ({ eventId, eventSlug, albumDetailsData }) => {
  const imageMedia =
    albumDetailsData?.getMedia?.filter((media) =>
      media?.type?.toLowerCase().includes("image")
    ) || [];

  return imageMedia.length > 0 ? (
    <div className="bg-white py-[3rem] lg:py-[8rem] px-4">
      {/* Grid layout for screens smaller than lg */}
      <div className="block mb-12">
        <div className="relative overflow-hidden">
          <h3 className="font-gill tracking-wide font-light text-4xl uppercase text-center text-black mb-10">
            The PhotoBook
          </h3>
          <div
            className="flex gap-6 animate-scroll"
            style={{
              width: `${
                imageMedia.length * 320 + (imageMedia.length - 1) * 24
              }px`, // 320px width + 24px gap
            }}
          >
            {/* First set of images */}
            {imageMedia?.map((image, index) => {
              if (image && image.meta?.s3_url) {
                return (
                  <div
                    key={`first-${index}`}
                    className="relative w-80 aspect-[0.865] cursor-pointer rounded-2xl transition duration-500 hover:scale-[1.02] flex-shrink-0"
                  >
                    <Image
                      placeholder="blur"
                      blurDataURL={`data:image/svg+xml;base64,${toBase64(
                        shimmer(700, 475)
                      )}`}
                      src={image.meta.s3_url}
                      layout="fill"
                      alt="gallery"
                      objectFit="cover"
                      className="rounded-2xl object-top"
                    />
                  </div>
                );
              }
            })}
            {/* Duplicate set for seamless loop */}
            {imageMedia?.map((image, index) => {
              if (image && image.meta?.s3_url) {
                return (
                  <div
                    key={`second-${index}`}
                    className="relative w-80 aspect-[0.865] cursor-pointer rounded-2xl transition duration-500 hover:scale-[1.02] flex-shrink-0"
                  >
                    <Image
                      placeholder="blur"
                      blurDataURL={`data:image/svg+xml;base64,${toBase64(
                        shimmer(700, 475)
                      )}`}
                      src={image.meta.s3_url}
                      layout="fill"
                      alt="gallery"
                      objectFit="cover"
                      className="rounded-2xl object-top"
                    />
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>

      <div
        className={`flex flex-col md:flex-row gap-8 justify-center items-center`}
      >
        <Link
          href={`https://${eventSlug}.${process.env.NEXT_PUBLIC_INAWO_ALBUM_SITE_END}`}
          passHref
        >
          <a target="_blank">
            <button
              className="px-6 py-2 rounded border border-black text-black text-xl font-gill hover:bg-white hover:text-black uppercase hover:scale-105 transition-transform duration-300"
              type="button"
            >
              See All On Photobook
            </button>
          </a>
        </Link>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${
              imageMedia.length * 320 + (imageMedia.length - 1) * 24
            }px);
          }
        }
        
        .animate-scroll {
          animation: scroll ${imageMedia.length * 4}s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  ) : (
    <></>
  );
};

export default Masonry;
